import { setupSocketIO } from '@qlik-trial/automations-ui'

export default function () {
  if (!window.socketIOConfig) {
    return
  }

  setupSocketIO(window.socketIOConfig)
}
